import { getAnnouncement } from "../../Announcement/Services/AnnouncementService";
import { useContext, useEffect, useState } from "react";
import { getTrans as T } from "../../../../Shared/Language";
import { TostMsg } from "../../../../App";
import { Link } from "react-router-dom/cjs/react-router-dom";
import moment from "moment";
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton from "react-loading-skeleton";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
const DashboardAnnouncement = () => {
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(true);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [announcementData, setAnnouncementList] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    await GetAnnouncement();
  };

  //Get the Employee from Announcement List.
  async function GetAnnouncement() {
    setIsloading(true);
    const body = {
      GUID: "",
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      year: "",
      AnnouncementType: 0,
      FutureAnnouncement: 0,
      PageNumber: 1,
      PageSize: 10,
    };
    try {
      const data = await getAnnouncement(body);
      setIsloading(false);
      setAnnouncementList(data?.Data);
    } catch (error) {
      toster.current.warn(ERROR_LIST.DashboardAnnouncement);
      setIsloading(false);
    }
  }
  
  return (
    <div className="col-xl-12 dashboard-announcements">
        <div className="card">
          <div className="card-body ">
      {Isloading ? (
        <Skeleton height={270} width="100%" style={{ marginBottom: "15px" }}/>
      ) : (
            <div className="custom-tab-1 custom-tab-11">
              <strong className="upcome">{T("Announcements")}</strong>
              <Link to="/Announcement" className="more-icon">
                <i className="fa fa-angle-right"></i>
              </Link>
              <div className="tab-content">
                <div className="tab-pane fade active show">
                  <div className="profile-about-me">
                    {announcementData?.slice(0, 3)?.map((Announcement, index) => {
                      return (
                        <Link to={`/Announcement/Detail/${Announcement?.GUID}`}>
                        <div className="boxs" key={index}>
                          <div className="text-center announce-date">
                            <img
                              src="/images/org-img/imp1.png"
                              className="w-100"
                            />
                          </div>
                          <div>
                            <p className="title break-text">{Announcement?.Title}</p>
                            <p className="announced-by">
                              On{" "}
                              {moment(Announcement?.Date).format("MMM DD YYYY")}
                            </p>
                          </div>
                        </div>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>)}
          </div>
        </div>
    </div>
  );
};
export default DashboardAnnouncement;
